import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CasinoPromotionComponent } from './casino-promotion.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [CasinoPromotionComponent],
  exports: [CasinoPromotionComponent]
})
export class CasinoPromotionModule { }



// WEBPACK FOOTER //
// ./src/app/components/casino-promotion/casino-promotion.module.ts